module.exports = __webpack_public_path__ + "static/media/Illus-Seasonal.daac3b69.png";